<template>
    <article class="project" :class="{ 'full': (isFull) }">

        <div class="project__content">

            <h1 class="project__title" v-if="project.title">
                {{ project.title }}
            </h1>

            <!-- <span class="project__location" v-if="project.content_alt">
                {{ project.content_alt }}
            </span> -->

            <div class="project__text">
                <vue-marked :key="project.key" v-if="isFull">{{ project.content }}</vue-marked>
                <vue-marked :key="project.key + '-alt'" v-else>{{ project.content_alt }}</vue-marked>
            </div>

            <div class="project__buttons">

                <button v-if="!isFull" class="btn-primary" @click="isFull = true">
                    {{ 'Read more' | i }}
                </button>
                <button v-else class="btn-primary" @click="isFull = false">
                    {{ 'Collapse' | i }}
                </button>

                <!-- <div class="project__link ">
                    {{ 'More information' | i }}
                    <span>→</span>
                </div> -->

            </div>

        </div>

        <div class="project__image">
            <!-- <pre>{{ project.imagenes_id }}</pre> -->
            <img :src="project.imagenes_id | asImg({ _w: 578, _h: 240 })" :alt="project.title">
        </div>

    </article>
</template>

<script>
import VueMarked from 'vue-marked';
export default {
    components: {
        VueMarked
    },
    name: 'ProjectsItem',
    props: {
        project: {
            type: Object,
            required: true
        }
    },
    data: () => {
        return {
            isFull: false
        }
    }
}
</script>


<style lang="scss">

.project {
    &.full {
        display: flex;
        flex-flow: column-reverse;
        .project__text {
            max-width: 100%;
            p {
                margin: 1.5em 0;
            }
        }
    }

    &__text {
        animation: all 0.3s ease-in-out;
    }

    .project__title {
        margin-top: 0em; 
        padding-top: 0em; 
    }

    h1, h2 {
        color: var(--white);
    }

    h1 {
        font-size: 48px;
    }

    h2 {
        font-size: 36px;
    }
    
    h3 {
        font-size: 28px;
    }

    h4, h5, h6 {
        font-size: 24px;
    }

    h2, h3, h4, h5, h6 {
        margin-top: 1.5em;
        margin-bottom: 0.5em;
        font-family: "Cormorant Garamond",serif !important;
        font-weight: 400;
    }

    &__image {
        animation: all 0.3s ease-in-out;
        img {
            /* height: 100%; */
            object-fit: initial;
            /*  */
            display: initial;
            /* display: block; */
            height: initial;
            animation: all 0.3s ease-in-out;
        }

    }
}
</style>